import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAuditLog } from 'app/models/audit-log/audit-log';
import { environment } from '@env/environment';

@Injectable({providedIn: 'root'})
export class AuditLogService {
  private api = environment.privateApi + 'AuditLog/';
  private http = inject(HttpClient);

  public getAuditLogs(entityKey: number, entityType: string): Observable<IAuditLog[]> {
    return this.http.get<IAuditLog[]>(this.api + 'GetCompleteAuditLog' + '/' + entityKey + '/' + entityType);
  }


}
